import type { Action } from 'state/actions';
import { addKey, addOrReplaceKey, removeKeys } from 'state/utils/collection';

import type { QuoteDetailsStateMap } from './details.model';
export function detailsReducer(state: QuoteDetailsStateMap = {}, action: Action): QuoteDetailsStateMap {
  switch (action.type) {
    case 'QUOTE_ACKED':
      return addKey(state, action.quoteId, action.quoteDetails);
    case 'QUOTE_RECEIVED':
      return action.quote.quoteDetails ? addOrReplaceKey(state, action.quoteId, action.quote.quoteDetails) : state;
    case 'PREVIOUS_QUOTE_LOADED':
    case 'BATCH_PREVIOUS_QUOTE_LOADED':
      return action.quote.quoteDetails !== undefined
        ? addOrReplaceKey(state, action.quoteId, action.quote.quoteDetails)
        : state;
    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
